import { Tabs, TabsProps } from "antd";
import React, { FC } from "react";
import { LegalEntities } from "./LegalEntities/LegalEntities";
import { Individuals } from "./Individuals/Individuals";

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "Физические лица",
    children: <Individuals />,
  },
  {
    key: "2",
    label: "Юридические лица",
    children: <LegalEntities />,
  },
];

export const Founders: FC = () => {
  return (
    <div>
      <Tabs defaultActiveKey="1" items={items} />
    </div>
  );
};
